export default __webpack_public_path__ + "static/media/app-store-icon.46434d45.svg";